import { USER_FLAGS } from 'constants'

import { ACCOUNT_INFO_SUCCESS } from 'state/actions/account'
import {
    USER_FLAGS_SUBMIT_REQUEST,
    USER_FLAGS_SUBMIT_SUCCESS,
    USER_FLAGS_SUBMIT_ERROR,
} from 'state/actions/user_flags'

const {
    USER_WITHOUT_CLAN_SCREEN_VISITED,
    CHALLENGES_PROMO_VISITED,
} = USER_FLAGS

const initialState = {
    submitting: false,
    errorMessage: '',
    [USER_WITHOUT_CLAN_SCREEN_VISITED]: false,
    [CHALLENGES_PROMO_VISITED]: false,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case USER_FLAGS_SUBMIT_REQUEST:
        return {
            ...state,
            errorMessage: '',
            submitting: true,
        }
    case USER_FLAGS_SUBMIT_SUCCESS:
        return {
            ...state,
            submitting: false,
            ...action.payload.flags,
        }
    case USER_FLAGS_SUBMIT_ERROR:
        return {
            ...state,
            submitting: false,
            errorMessage: action.payload.errorMessage,
        }
    case ACCOUNT_INFO_SUCCESS:
        return {
            ...state,
            ...action.payload.flags,
        }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/user_flags.js